export default {
    namespaced: true,

    state: {
        show: false,
        // What pdf.js fetches. May be a backend proxy URL.
        url: "",
        name: "",
        // The original document URL, for the "Open in new tab" link. Same as
        // `url` unless the document is being read through the proxy.
        sourceUrl: "",
    },

    getters: {
        getPdfViewer: (state) => state,
    },

    mutations: {
        OPEN(state, { url, name, sourceUrl }) {
            state.url = url || "";
            state.name = name || "";
            state.sourceUrl = sourceUrl || url || "";
            state.show = true;
        },
        CLOSE(state) {
            state.show = false;
            state.url = "";
            state.name = "";
            state.sourceUrl = "";
        },
    },

    actions: {
        open({ commit }, payload) {
            commit("OPEN", payload);
        },
        close({ commit }) {
            commit("CLOSE");
        },
    },
};
